import * as React from "react";

import IconButton from "@replo/design-system/components/button/IconButton";
import { Minus, Plus } from "lucide-react";

type QuantityControlProps = {
  value: number;
  onIncrement: () => void;
  onDecrement: () => void;
  label: React.ReactNode;
  minValue?: number;
  maxValue?: number;
  isViewOnly: boolean;
};

const QuantityControl: React.FC<QuantityControlProps> = ({
  value,
  onIncrement,
  onDecrement,
  label,
  minValue = 0,
  maxValue,
  isViewOnly,
}) => {
  return (
    <div className="flex items-center justify-between border border-border bg-white rounded-md px-2 text-default h-8">
      <div className="flex w-full items-center gap-1">
        {!isViewOnly && (
          <IconButton
            variant="tertiary"
            size="sm"
            onClick={onDecrement}
            disabled={value <= minValue}
            icon={<Minus size={16} />}
          />
        )}

        <span className="flex-1 text-center text-sm font-body">{label}</span>

        {!isViewOnly && (
          <IconButton
            variant="tertiary"
            size="sm"
            onClick={onIncrement}
            disabled={value >= (maxValue ?? Number.POSITIVE_INFINITY)}
            icon={<Plus size={16} />}
          />
        )}
      </div>
    </div>
  );
};

export default QuantityControl;
